module.exports = __webpack_public_path__ + "img/logo.c365f4eb.svg";